/* (ignored) */


//////////////////
// WEBPACK FOOTER
// readable-stream (ignored)
// module id = 0
// module chunks = 0 1